// =====================================================================
// src/lib/contratos.js — quais módulos cada contratante tem, sem DOM
//
// A tela de Configurações, na visão do Administrador do Sistema, mostra
// para o hotel escolhido: os módulos do PRÉDIO e, embaixo, os de cada
// IMOBILIÁRIA — cada um com o interruptor Ligado/Desligado.
// "Todos os módulos podem ser ligados e desligados a qualquer momento
// pelo Administrador do Sistema" (Hugo, 21/09/2026).
//
// O catálogo (`modulos`, 0002) já diz quem pode contratar cada módulo:
//   nivel = 'cliente'        só o prédio (governança, manutenção…)
//   nivel = 'imobiliaria'    só a imobiliária (financeiro)
//   nivel = 'ambos'          os dois (reservas, hóspedes…)
// e `essencial` = vem ligado e não se desliga (usuários, configurações).
// Quem escreve é `definir_contrato` (0048); aqui é só a leitura.
// =====================================================================

// Um módulo cabe a este contratante? `imobiliariaId` nulo = o prédio.
export function cabeAo(modulo, imobiliariaId) {
  if (modulo.nivel === 'ambos') return true;
  return imobiliariaId ? modulo.nivel === 'imobiliaria' : modulo.nivel === 'cliente';
}

// O contrato vigente deste contratante para o módulo, se houver.
export function contratoDe(contratos, imobiliariaId, chave) {
  return (contratos || []).find(c => c.modulo_chave === chave && (c.imobiliaria_id || null) === (imobiliariaId || null)) || null;
}

// Um contrato "está ligado" se ativo e sem `ate` no passado — a mesma
// leitura de `app.tem_modulo` (0002), para a tela não dizer uma coisa e o
// banco outra.
export function ligado(contrato, hoje) {
  if (!contrato || !contrato.ativo) return false;
  return !contrato.ate || contrato.ate >= hoje;
}

// As linhas da tabela de um contratante: [{ chave, nome, descricao,
// essencial, ligado, desde, ate }], na ordem do catálogo.
export function linhasDoContratante(modulos, contratos, imobiliariaId, hoje) {
  return (modulos || [])
    .filter(m => cabeAo(m, imobiliariaId))
    .slice().sort((a, b) => (a.ordem - b.ordem) || String(a.chave).localeCompare(String(b.chave)))
    .map(m => {
      const c = contratoDe(contratos, imobiliariaId, m.chave);
      return { chave: m.chave, nome: m.nome, descricao: m.descricao || '', essencial: !!m.essencial,
        ligado: !!m.essencial || ligado(c, hoje), desde: c ? c.desde : null, ate: c ? c.ate : null };
    });
}

// Quantos ligados de quantos, para o subtítulo do bloco: "5 de 12 ligados".
export function resumoDoContratante(linhas) {
  const n = linhas.length, l = linhas.filter(x => x.ligado).length;
  return `${l} de ${n} ligado${l !== 1 ? 's' : ''}`;
}
